import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Heading } from "react-bulma-components";
import ReactDOM from "react-dom";
import { usePreviousImmediate, useTimeoutWhen } from "rooks";
import { store } from "store/store";
import { getStageLabel } from "backend/src/common/i18n";
import { useI18n } from "i18n/I18nProvider";
import styles from "./styles.module.scss";

const SPLASH_VISIBLE_TIME = 2000;

export const SplashScreen = observer(() => {
  const { locale, t } = useI18n();
  const [isSplashScreenVisible, setIsSplashScreenVisible] =
    useState<boolean>(false);
  const [willBeSplashScreenHidden, setWillBeSplashScreenHidden] =
    useState<boolean>(false);
  const currentStage = store.gameState.stage;
  const previousStage = usePreviousImmediate(currentStage);
  useTimeoutWhen(
    () => {
      setIsSplashScreenVisible(false);
    },
    SPLASH_VISIBLE_TIME,
    isSplashScreenVisible,
  );
  useTimeoutWhen(
    () => {
      setWillBeSplashScreenHidden(true);
    },
    SPLASH_VISIBLE_TIME - 800,
    isSplashScreenVisible,
  );
  useEffect(() => {
    if (previousStage !== currentStage) {
      setIsSplashScreenVisible(true);
      setWillBeSplashScreenHidden(false);
    }
  }, [currentStage, previousStage]);
  if (!isSplashScreenVisible) {
    return null;
  }
  const stageName = getStageLabel(locale, currentStage);
  return ReactDOM.createPortal(
    <div
      className={classNames(styles.screen, "animate__animated", {
        animate__fadeOut: willBeSplashScreenHidden,
      })}
    >
      <Heading
        className="animate__animated animate__fadeIn"
        size={6}
        weight="normal"
      >
        {t("splash.starting")}
      </Heading>
      <Heading className="animate__animated animate__fadeIn animate__slow">
        {stageName}
      </Heading>
    </div>,
    document.body,
  );
});
